import { StorageService } from './services/storage.service';
import { Component } from '@angular/core';
import { EleicaoService } from 'src/app/services/eleicao.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  constructor(
    protected storage: StorageService,
    protected eleicaoService: EleicaoService,
  ){ 
    eleicaoService.logoEleicao = sessionStorage.getItem("logoEleicao");
  }

}


